<template>
  <div class="gate_wrapper_center">
    <section class="m-content m-content-full signIn">
      <div class="gate_right_side col" :class="{'m--hidden-tablet-and-mobile':intro}">
        <form v-on:submit.prevent="Login">
          <div class="card row">
            <div class="card__title">
              <h2>Welcome to Carbon!</h2>
            </div>
            <div class="card__body">
              <div class="row">
                <div class="col-12">
                  <div class="material--input--group">
                    <input
                      title="Phone number"
                      id="phone"
                      name="phone"
                      v-model="phone"
                      type="text"
                      v-ep-restrict.number
                      maxlength="11"
                      required
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label for="phone">Phone number</label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="material--input--group">
                    <input
                      title="Enter PIN"
                      id="password"
                      name="password"
                      v-model="password"
                      v-ep-restrict.number
                      pattern="[0-9]*"
                      inputmode="numeric"
                      maxlength="4"
                      type="password"
                      required
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label for="password">Enter PIN</label>
                  </div>
                </div>
                <p class="col-6" style="text-align: left">
                  <router-link :to="{ name: 'forget' }">Reset PIN?</router-link>
                </p>
                <p class="col-6" style="text-align: right">
                  <router-link :to="{ name: 'suspicious-activity' }">Suspicious Activity?</router-link>
                </p>
                <div class="col-12">
                  <span class="m-switch m-switch--sm">
                    <label>
                      <input type="checkbox" checked name="remember" />
                      <span class="m--margin-top-5"></span>&nbsp;&nbsp;Remember me
                    </label>
                  </span>
                </div>
              </div>
            </div>

            <div class="card__footer">
              <button
                :disabled="is_submiting"
                type="submit"
                class="btn m-btn--square btn-block btn-primary btn-lg m-btn"
              >Sign In</button>
              <p class="my-2 text-center">
                OR
              </p>
              <div class="d-flex justify-content-center">
                <a href="https://play.google.com/store/apps/details?id=com.lenddo.mobile.paylater&referrer=utm_source%3Dcarbonportal%26utm_medium%3Dcarbonnavbutton%26utm_term%3Dcarbonportal%26utm_content%3Dcarbonnavbutton%26utm_campaign%25carbonportal%26anid%3Dadmob">
                  <img src="/images/svg/play-store.svg" alt="Download from Play store">
                </a>
                <a href="https://apps.apple.com/us/app/carbon-by-one-finance/id1494856668?ls=1">
                  <img src="/images/svg/apple-store.svg" alt="Download from App store">
                </a>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div
        class="gate_signIn_fs col m--hidden-desktop"
        :class="{'m--hidden-tablet-and-mobile':!intro}"
      >
        <div class="text-center row">
          <div class="fs__footer">
            <button
              type="button"
              @click="intro=!intro"
              class="btn-fs-show btn m-btn--square btn-block btn-primary btn-lg m-btn"
            >Sign In</button>
            <p class="my-2 text-center">
              OR
            </p>
            <div class="d-flex justify-content-center">
              <a href="https://play.google.com/store/apps/details?id=com.lenddo.mobile.paylater&referrer=utm_source%3Dcarbonportal%26utm_medium%3Dcarbonnavbutton%26utm_term%3Dcarbonportal%26utm_content%3Dcarbonnavbutton%26utm_campaign%25carbonportal%26anid%3Dadmob">
                <img src="/images/svg/play-store.svg" alt="Download from Play store">
              </a>
              <a href="https://apps.apple.com/us/app/carbon-by-one-finance/id1494856668?ls=1">
                <img src="/images/svg/apple-store.svg" alt="Download from App store">
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="m-gate_bg gate_bg_not_mobile m-gate_bg--signIn">
      <img src="./../../../static/media/demo/default/img/misc/signIn_bg.png" alt />
    </div>
    <div class="m-gate_bg gate_bg_only_mobile">
      <img src="./../../../static/media/demo/default/img/misc/signIn_bg__mobile.png" alt />
    </div>
  </div>
</template>
<script>
import vue from "vue";
import InputFilter from "./../../filters/Input";
import { getWallet } from "./../../api/wallet/walletService";
import { getCategories } from "./../../api/billsPayments/billsPaymentsService";
InputFilter();

export default {
  data: () => ({
    intro: true,
    is_submiting: false,
    phone: null,
    password: null
  }),
  components: {},
  mounted() {
    this.$swal.close();
    // if we are coming from idle state redirect grab phone number from params
    if (this.$route.params.idleRedirectPhoneNumber) {
      this.phone = this.$route.params.idleRedirectPhoneNumber;
    }

    if (
      this.$store.state.Auth.auth_token &&
      this.$store.state.Auth.browser_token &&
      this.$store.state.Auth.user_data &&
      this.$store.state.Auth.phonenumber
    ) {
      this.$store.dispatch("redirect", "wallet");
    }
    $("body")
      .addClass("m--bg-white")
      .removeClass("m-content--skin-light2");
    $(".m-brand--skin-light").removeClass("m-brand--skin-light2");
    $(".m-stack__item.m-brand.m-brand--skin-light").removeClass(
      "m-brand--skin-light"
    );
  },
  methods: {
    Login() {
      let is_fcr_user = localStorage.getItem("is_fcr_user");
      const queryParams = this.$route.query;
      const redirectedFrom = queryParams && queryParams["redirect-from"];
      this.is_submiting = true;
      let phonenumber = this.phone;
      this.$store.dispatch("loader", true);
      this.$store.dispatch("saveToken", { phonenumber: phonenumber });
      this.$store
        .dispatch("login", { phone: phonenumber, password: this.password })
        .then(response => {
          this.$store.dispatch("saveToken", response.response.data);
          if (this.$store.state.Auth.browser_token == null) {
            this.$store.dispatch("loader", false);
            this.$store.dispatch("redirect", {name: "verify", params: queryParams});
          }
          if (is_fcr_user == "true" || is_fcr_user === true) {
            this.$store.dispatch("loader", false);
            this.$store.dispatch("redirect", "credit-report");
          } else if (
            this.$store.state.Auth.is_new_user == "true" ||
            this.$store.state.Auth.is_new_user === true
          ) {
            this.$store.dispatch("loader", false);
            this.$store.dispatch("redirect", "dashboard");
          } else if (redirectedFrom) {
            this.$store.dispatch("loader", false);
            this.$store.dispatch("redirect", redirectedFrom);
          } else {
            getCategories()
              .then(response => {
                this.is_submiting = false;
                this.$store.dispatch("loader", false);
                this.$store.dispatch("redirect", {
                  name: "wallet",
                  params: { ref: "from-login" }
                });
              })
              .finally(() => {
                this.$store.dispatch("loader", false);
              });
          }
        })
        .catch(error => {
          this.is_submiting = false;
          this.password = null;
          let dataResponse = error;
          this.$store.dispatch("handleError", error);
          this.$store.dispatch("loader", false);
        });
    }
  }
};
</script>
